import psHttp from '@patsnap/common-ps-http';
import { workspaceApiUrlPrefix } from '@cores/constants/envConfig';
export function checkGroupApi({ name, cache = false }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/group/check`,
        method: 'GET',
        params: {
            name,
        },
        cache,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function getGroupsApi({ name = '', page = 0, limit = 20, cache = false, }) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/group/think`,
        method: 'GET',
        params: {
            name,
            page,
            limit,
        },
        cache,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
